import { AttendeeDetails } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<AttendeeDetails>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminAttendeeDetailsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminAttendeeDetails.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminAttendeeDetails.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminAttendeeDetails.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminAttendeeDetails.reset.type]: actionsHandlers.handleGetOneReset,
});

export default adminAttendeeDetailsReducer;
